import type { CSSProperties } from 'react';

import { fullWidthToHalfWidthNumber } from '@/utils/japaneseText';
import { PATIENT_TELEPHONE_MAX_LENGTH } from '@pages/main/patient/types';

/** Shrink-wrap to the widest menu row; cap at viewport with horizontal scroll if needed. */
export const historyDropdownPopupStyle: CSSProperties = {
  width: 'max-content',
  maxWidth: '96vw',
  overflowX: 'auto',
};

export const normalizePostalDigits = (val: string) =>
  fullWidthToHalfWidthNumber(val).replace(/\D/g, '');

export const normalizePaddedInsurerNumber = (value: string): string => {
  const normalized = fullWidthToHalfWidthNumber(String(value || '').trim())
    .replace(/[－ー―ｰ]/g, '-')
    .replace(/[^0-9-]/g, '');

  if (!normalized) return '';

  const subNumberMatch = normalized.match(/^(\d+)-(\d+)$/);
  if (subNumberMatch) {
    return `${subNumberMatch[1].padStart(8, '0')}-${subNumberMatch[2]}`;
  }

  if (/^\d+$/.test(normalized)) {
    return normalized.padStart(8, '0');
  }

  return normalized;
};

export const normalizePatientTelephone = (val: string) =>
  fullWidthToHalfWidthNumber(
    String(val || '')
      .slice(0, PATIENT_TELEPHONE_MAX_LENGTH)
      .replace(/[^0-9\-０-９－ー―ｰ]/g, '')
  ).replace(/[－ー―ｰ]/g, '-');
